import React from 'react';
import { Link, useLocation } from 'react-router';
import { Check } from 'lucide-react';

export default function VerseDeliveryConfirmation() {
  const { state } = useLocation();
  const subscription = state?.subscription;
  const firstDelivery = (state?.deliveries || [])
    .filter((delivery) => delivery.status === 'scheduled')
    .sort((left, right) => new Date(left.scheduledAt) - new Date(right.scheduledAt))[0];
  const scheduledDate = firstDelivery ? new Date(firstDelivery.scheduledAt) : null;
  const when = scheduledDate && !Number.isNaN(scheduledDate.getTime())
    ? new Intl.DateTimeFormat('en-US', { dateStyle: 'full', timeStyle: 'short', timeZone: subscription?.timezone }).format(scheduledDate)
    : null;

  return (
    <main className="rhythm-confirm">
      {subscription ? <span className="confirm-check"><Check aria-hidden="true" /></span> : null}
      <p className="rhythm-eyebrow">Optional verse delivery</p>
      <h1>{subscription ? 'Your schedule is saved.' : 'Your verse schedules'}</h1>
      {subscription ? (
        <p>
          {when ? `Your first verse is scheduled for ${when}` : 'Your verse delivery is scheduled'}
          {subscription.timezone ? ` (${subscription.timezone})` : ''}.
          {' '}It will arrive at your signed-in email address.
        </p>
      ) : (
        <p>Open your schedules to see upcoming deliveries or create a new one.</p>
      )}
      <p>Today’s prayer, Bible reader, and devotional are ready whenever you are.</p>
      <Link className="rhythm-primary" to="/">Return to today</Link>
      <p><Link to="/prayer/schedule">Manage schedules</Link></p>
    </main>
  );
}
